import clsx from 'clsx'

const DEFAULT_OPTIONS = {
  hideQuickAdd: false,
  hideSwatches: false,
  hidePromolines: false,
  hideBadges: false
}
const SkeletonImage = () => {
  return (
          <div class="relative w-full overflow-hidden aspect-4/5 animate-pulse bg-neutral-light">
          </div>
  )
}
const SkeletonSwatches = () => {
  return (
      <div class="flex gap-1">
          {
              [1, 2, 3].map((i) => (
                  <button key={i} class="size-6 rounded-full overflow-hidden bg-neutral-light">
                  </button>
              ))
          }
      </div>
  )
}

const SkeletonDetails = () => {
  return (
      <div class="flex flex-col pb-4">
          <div className={'h-4 md:h-5 bg-neutral-light'}></div>
          <div className={'h-4 md:h-5 bg-neutral-light'}></div>
      </div>
  )
}

const SkeletonPromolines = ({ hideQuickAdd = false }) => {
  return (
      <div class="flex gap-2 justify-between">
          <div class="flex flex-col gap-1 grow">
              <div className={'h-3 grow bg-neutral-light'}></div>
              <div className={'h-3 grow bg-neutral-light'}></div>
          </div>
          {!hideQuickAdd && <div className={'size-8 overflow-hidden rounded-full bg-neutral-light'}></div>}
      </div>
  )
}

export const SkeletonCard = ({ className, options = DEFAULT_OPTIONS }) => {
  return (
      <div class={clsx('flex flex-col w-full grow', className)}>
          <SkeletonImage />
          <div class="animate-pulse flex flex-col justify-between p-4 pt-2 md:p-6 grow">
              <div class="flex flex-col justify-between gap-4">
                  {!options.hideSwatches && <SkeletonSwatches />}
                  <SkeletonDetails />
              </div>
              {!options.hidePromolines && <SkeletonPromolines hideQuickAdd={options.hideQuickAdd} />}
          </div>
      </div>
  )
}
